// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import FeedbackIcon from '@mui/icons-material/Feedback';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import OpacityIcon from '@mui/icons-material/Opacity';
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  external: icon('ic_external'),
  calendar: icon('ic_calendar'),
};
const navConfig = [
  {
    subheader: '',
    items: [
      { title: '首页', path: PATH_DASHBOARD.home, icon: ICONS.dashboard },
      {
        title: '设备管理',
        path: PATH_DASHBOARD.deviceManage.root,
        icon: <AssignmentIcon />,
        children: [
          { title: '设备列表', path: PATH_DASHBOARD.deviceManage.list },
          { title: 'SN号类型', path: PATH_DASHBOARD.deviceManage.deviceTypeList },
        ],
      },
      {
        title: '反馈管理',
        path: PATH_DASHBOARD.feedbackManage.root,
        icon: <FeedbackIcon />,
        children: [
          { title: '反馈列表', path: PATH_DASHBOARD.feedbackManage.list },
        ],
      },
      {
        title: 'OTA升级管理',
        path: PATH_DASHBOARD.otaManage.root,
        icon: <SystemUpdateIcon />,
        children: [
          { title: '固件列表', path: PATH_DASHBOARD.otaManage.list },
        ],
      },
      // {
      //   title: '鱼缸类型管理',
      //   path: PATH_DASHBOARD.tankType.root,
      //   icon: <InsertPhotoIcon />,
      //   children: [
      //     { title: '一级类型列表', path: PATH_DASHBOARD.tankType.list },
      //     { title: '二级类型列表', path: PATH_DASHBOARD.tankType.secondList },
      //   ],
      // },
      {
        title: 'APP用户管理',
        path: PATH_DASHBOARD.appUserManage.root,
        icon: <PeopleAltIcon />,
        children: [
          { title: '用户列表', path: PATH_DASHBOARD.appUserManage.list },
        ],
      },
      {
        title: '鱼缸管理',
        path: PATH_DASHBOARD.tankManage.root,
        icon: <OpacityIcon />,
        children: [
          { title: '鱼缸列表', path: PATH_DASHBOARD.tankManage.list },
        ],
      },
      {
        title: '自动化模板升级',
        path: PATH_DASHBOARD.automationMigration.root,
        icon: <UpgradeIcon />,
        children: [
          { title: '一键升级', path: PATH_DASHBOARD.automationMigration.list },
        ],
      },
      // {
      //   title: '系统用户管理',
      //   path: PATH_DASHBOARD.userManage.root,
      //   icon: <PeopleAltIcon />,
      //   children: [
      //     { title: '系统用户列表', path: PATH_DASHBOARD.userManage.list },
      //   ],
      // },

    ],
  },
];


export default navConfig;
